import { useIntl } from 'react-intl';
import AiChatInput from './AiChatInput';
import Search from './Search';
import {
  aiChatPlaceholderMessage,
  searchPlaceholderMessage,
} from './searchStyles';

type Props = Readonly<{
  isAiChatMode: boolean;
  containerClasses: string;
  dataTestId?: string;
  focusOnMount: boolean;
  aiChatValue: string;
  onAiChatValueChange: (value: string) => void;
  onAiSubmit: (value: string) => void;
}>;

/**
 * Renders the AI Chat input or the regular Search input depending on the
 * active Search/AI Chat toggle mode.
 */
const DashboardSearchInput = ({
  isAiChatMode,
  containerClasses,
  dataTestId,
  focusOnMount,
  aiChatValue,
  onAiChatValueChange,
  onAiSubmit,
}: Props) => {
  const intl = useIntl();

  return isAiChatMode ? (
    <AiChatInput
      placeholder={intl.formatMessage(aiChatPlaceholderMessage)}
      containerClasses={containerClasses}
      dataTestId={dataTestId}
      focusOnMount={focusOnMount}
      value={aiChatValue}
      onChange={onAiChatValueChange}
      onSubmit={onAiSubmit}
    />
  ) : (
    <Search
      placeholder={intl.formatMessage(searchPlaceholderMessage)}
      containerClasses={containerClasses}
      dataTestId={dataTestId}
      focusOnMount={focusOnMount}
    />
  );
};

export default DashboardSearchInput;
